export default __webpack_public_path__ + "static/char-s-47-ko-268f352d40f6ba5b5569afd57f617f9f.webp";